import accounting from "accounting";

export function PhoneMask(phone: string) {
  if (!phone)
    return phone;

  return phone
    .replace(/\D/g, "")             //Remove tudo o que não é dígito
    .replace(/^(\d{2})(\d)/g, "($1) $2") //Coloca parênteses em volta dos dois primeiros dígitos
    .replace(/(\d)(\d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
}

export function CPFMask(cpf: string) {
  if (!cpf)
    return cpf;

  return cpf.replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")///Primeiro ponto
    .replace(/(\d{3})(\d)/, "$1.$2")///Segundo ponto
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")///Hifen
}
export function CNPJMask(cnpj: string) {
  if (!cnpj)
    return cnpj;

  return cnpj.replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "$1.$2")///Primeiro ponto
    .replace(/(\d{3})(\d)/, "$1.$2")///Segundo ponto
    .replace(/(\d{3})(\d)/, "$1/$2")///Segundo ponto
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2")///Hifen
}

export function CEPMask(cep: string) {
  if (!cep)
    return cep;

  return cep.replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1-$2")///Primeiro ponto
}

export function CentsToHuman(cents: number) {
  return PriceToCurrency(cents / 100);
}

export function PriceToCurrency(price: number) {
  return accounting.formatMoney(price, "R$ ", 2, ".", ",");
}
export function CurrencyToCents(currency: string) {
  return accounting.unformat(currency, ',') * 100;
}

export function MaskPrice(price: string, allowNegative: boolean = false) {
  const regex = allowNegative ? /[^0-9-]/g : /\D/g;
  return "R$ " + price.replace(/(-)\1{1,}/g, "-") ///Remove os - se houver mais de um
    .replace(regex, "") ///Remove tudo que não for número
    .replace(/(\d)(\d{2})$/, "$1,$2") ///Coloca virgula após os 2 últimos
    .replace(/(?=(\d{3})+(\D))\B/g, "."); ///Separador de milhar
}

export function Wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function Clamp(min, value, max) {
  return Math.min(Math.max(value, min), max);
}

export function GetFileFromURL(url: string, resourceUrl: string) {
  if (url && (url.startsWith("FILE-S3://") || url.startsWith("file://")))
    return resourceUrl;
  else
    return url;
}

export function StringToBool(value: string) {
  if (typeof (value) == "number")
    return value !== 0;
  else
    return value != null && (value.toLowerCase() === "true" || value === "1");
}

export function ReplaceAll(stringBase: string, searchValue: string, replaceValue: string): string {
  return stringBase.split(searchValue).join(replaceValue);
}

export function InsertStringAt(stringBase: string, stringToBeInserted: string, index: number) {
  return stringBase.slice(0, index) + stringToBeInserted + stringBase.slice(index);
}

export function GroupBy(values: any[], groupPropriety: string) {
  return values.reduce(function (previousValues, currentValue) {
    (previousValues[currentValue[groupPropriety]] = previousValues[currentValue[groupPropriety]] || []).push(currentValue);
    return previousValues;
  }, {});
};

export function Sort<Type>(values: Type[], parameter: (value: Type) => any, descending = false) {
  return values.sort((a, b) => {
    const valueA = parameter(a);
    const valueB = parameter(b);

    let result = 0;
    if (valueA < valueB) result = -1;
    else if (valueA > valueB) result = 1;

    return descending ? -result : result;
  });
}

///PaddingLength = quantos caracteres remove "a mais" para preencher com ...
export function truncateString(string: string, maxLength = 50, paddingLength = 3) {
  if (string.length <= maxLength) return { baseString: string, extension: "" };

  const startExtensionIndex = string.lastIndexOf(".");
  const extension = startExtensionIndex !== -1 ? string.slice(startExtensionIndex) : "";
  const base = startExtensionIndex !== -1 ? string.slice(0, startExtensionIndex) : string;

  const maxBase = maxLength - extension.length - paddingLength; // 3 dos "..."
  const baseString = base.slice(0, maxBase);

  return { baseString, extension };
}

export function bytesToHuman(bytes: number) {
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);

  return `${value.toFixed(2).replace(/\.00$/, "")} ${units[i]}`;
}

///Supoe que timestamp está em utc 0
export function customDateTimeFormat(timestamp: number | string, hourSuffix = "h", minutesSuffix = "") {
  const dateUtc = new Date(timestamp);
  ///TimezoneOffset retorna em minutos, então converte para millisegundos
  const date = new Date(dateUtc.getTime() - dateUtc.getTimezoneOffset() * 60000);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // meses começam do 0
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hour}${hourSuffix}${minutes}${minutesSuffix}`;
}
